import React, { type FC } from "react";
import { MoreOutlined } from "@ant-design/icons";
import { Dropdown } from "antd";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../../components/shared";
import { AppStrings } from "../../../../utils/constants/AppStrings";
import { templateClonePath } from "../clonePaths";

type Props = {
  templateId: string;
};

/**
 * Per-row "⋯" menu on the templates list. Duplicate opens the create wizard
 * with a clone preview; nothing is persisted until the operator saves.
 */
const TemplateRowActions: FC<Props> = ({ templateId }) => {
  const navigate = useNavigate();

  return (
    /* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
    <div onClick={(event) => event.stopPropagation()}>
      <Dropdown
        menu={{
          items: [
            {
              key: "duplicate",
              label: AppStrings.PAM_DYNAMIC_BONUS_TEMPLATE_ACTION_DUPLICATE,
            },
          ],
          onClick: () => navigate(templateClonePath(templateId)),
        }}
        trigger={["click"]}
      >
        <Button
          intent="neutral"
          variant="ghost"
          iconLeft={<MoreOutlined />}
          aria-label={AppStrings.PAM_DYNAMIC_BONUS_TEMPLATE_ACTIONS_LABEL}
          data-testid={`template-actions-${templateId}`}
        />
      </Dropdown>
    </div>
  );
};

export default TemplateRowActions;
